import { render, staticRenderFns } from "./HalfRankTile.vue?vue&type=template&id=b4782180&scoped=true"
import script from "./HalfRankTile.vue?vue&type=script&lang=js"
export * from "./HalfRankTile.vue?vue&type=script&lang=js"
import style0 from "./HalfRankTile.vue?vue&type=style&index=0&id=b4782180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4782180",
  null
  
)

export default component.exports